var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');

var template = require('../templates/context-menu.jade');

var dispatcher = require('../dispatcher');

module.exports = Backbone.View.extend({
	autoRender: true,
	model: null,
	events: {
		'click .play-sub': 'playSubtitle',
		'click .edit': 'editSubtitle',
		'click .add': 'addSubtitle',
		'click .delete': 'deleteSubtitle',
		'click .merge': 'mergeSubtitle',
		'click .split': 'splitSubtitle',
		'click .undo': 'undoSubtitle',
		'click .redo': 'redoSubtitle'
	},
	initialize: function (options) {
		_.apply(this, options);

		_.bindAll(this, 'playSubtitle', 'destroy_context');

		if (this.autoRender) this.render();

		$(window).on('click keydown', this.destroy_context);
	},
	render: function () {
		this.setElement(template());

		return this;
	},
	playSubtitle: function () {
		dispatcher.emit(dispatcher.events.PLAY_SECTION, this.model, true);
	},
	editSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.EDIT_SUBTITLE);
	},
	addSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.ADD_SUBTITLE);
	},
	deleteSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.DELETE_SUBTITLE);
	},
	mergeSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.MERGE_SUBTITLE);
	},
	splitSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.SPLIT_SUBTITLE);
	},
	undoSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.UNDO_CHANGES);
	},
	redoSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.REDO_CHANGES);
	},

	destroy_context: function (e) {
		if ((e.type == 'keydown' && e.keyCode == 27) || e.type == 'click') {
			$(window).off('click', this.destroy_context);
			this.remove();
		}
	}
});


// WEBPACK FOOTER //
// ./app/views/context-menu.js